import { ShippingClient } from 'clients/shipping-client';
import { notifyError } from 'actions/action-notifications';
import axios, { AxiosError } from 'axios';
import { IGeneratedDocumentResponse } from 'models/document_generator/IGeneratedDocumentResponse';
import { GeneratorUtil } from 'components/document/generator/generator-util';
import printJS from 'print-js';
import { IPrintLabelButton } from './types';

export const printLabel = async ({
  orderId,
  deliveryMethod,
  dispatch,
  setPrintLabelClicked,
}: IPrintLabelButton) => {
  try {
    setPrintLabelClicked?.(true);
    const generatedLabelResponse = await ShippingClient.fetchLabel(orderId);
    const provider = generatedLabelResponse?.data?.provider;
    const labelObject: IGeneratedDocumentResponse = {
      fileType: generatedLabelResponse.data.fileType,
      generatedDocument: generatedLabelResponse.data.labelBase64,
      mimeType: `image/${generatedLabelResponse.data.fileType}`,
    };

    if (provider === 'ups') {
      const trackingNumber = generatedLabelResponse.data.printInformation?.tracking_number;
      if (trackingNumber) {
        const viewableResult = GeneratorUtil.convertToViewable(labelObject, `${trackingNumber}`);
        return printJS({
          printable: viewableResult.url,
          documentTitle: viewableResult.fileName,
          type: 'image',
          showModal: true,
        });
      }
    }

    if (
      provider === 'internaldelivery' ||
      provider === 'phoxcourier' ||
      provider === 'lablogistics' ||
      provider === 'nuvizz' ||
      provider === 'associatedcourier' ||
      provider === 'fetchgoat' ||
      provider === 'fedex' ||
      provider === 'PharmacyNotConfiguredCourier'
    ) {
      return printJS({
        printable: generatedLabelResponse?.data?.labelBase64,
        documentTitle: 'Shipping Label',
        type: 'pdf',
        base64: true,
      });
    }
  } catch (error) {
    // Provide the user with a descriptive message, including the AxiosError message if present
    let responseErrorMessage;
    if (axios.isAxiosError(error)) {
      const responseError = error as AxiosError<{ message?: string }>;
      responseErrorMessage = responseError.response?.data?.message ?? responseError.response?.data;
    } else {
      responseErrorMessage = null;
    }
    const generateShippingLabelMessage = 'Unable to generate shipping label.';
    const notifyMessage =
      responseErrorMessage == null
        ? generateShippingLabelMessage
        : `${generateShippingLabelMessage} ${responseErrorMessage}`;
    setPrintLabelClicked?.(false);
    dispatch?.(notifyError(notifyMessage));
    throw error;
  }
};
